import { useMemo } from 'react'
import { exerciseGoalQueryOptions } from '@/src/queries/exercise-queries'
import { useSuspenseQuery } from '@tanstack/react-query'
import { useTranslation } from 'react-i18next'

import type { ExerciseGoalItem } from '../types/statistics'

const PLACEHOLDER_VALUE = '--'

export function useExerciseGoal() {
  const { t } = useTranslation(['statistics', 'common'])
  const exerciseGoalQuery = useSuspenseQuery(exerciseGoalQueryOptions())

  const exerciseGoal = useMemo<ExerciseGoalItem>(() => {
    const goalValue =
      exerciseGoalQuery.status === 'success' ? exerciseGoalQuery.data : null

    return {
      label: t('statistics:exercise_goal_label'),
      value:
        goalValue == null
          ? PLACEHOLDER_VALUE
          : t('statistics:exercise_goal_value_per_week', {
              count: goalValue,
            }),
      currentValue: goalValue ?? null,
    }
  }, [exerciseGoalQuery.data, exerciseGoalQuery.status, t])

  return {
    exerciseGoal,
    refetchExerciseGoal: exerciseGoalQuery.refetch,
  }
}
